export * from '@fhs/routing/src/routes/signout';
export { default } from '@fhs/routing/src/routes/signout';
